import { type FormEvent, useState } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'

import { useMe, useRegister } from '../api/hooks'
import { Button, Card, ErrorText, Field, Input } from '../components/ui'

const MIN_PASSWORD_LENGTH = 10

export default function Register() {
  const { data: user } = useMe()
  const register = useRegister()
  const navigate = useNavigate()
  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  if (user) return <Navigate to="/" replace />

  const tooShort = password.length > 0 && password.length < MIN_PASSWORD_LENGTH

  function onSubmit(event: FormEvent) {
    event.preventDefault()
    register.mutate(
      { email, password, display_name: displayName },
      { onSuccess: () => navigate('/', { replace: true }) },
    )
  }

  return (
    <div className="mx-auto max-w-sm">
      <h1 className="mb-1 text-2xl font-semibold tracking-tight">Create an account</h1>
      <p className="mb-6 text-sm text-muted">
        Invent a language, build its vocabulary, and learn it.
      </p>

      <Card>
        <form onSubmit={onSubmit} className="space-y-4">
          <Field label="Display name">
            <Input
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
              maxLength={80}
              autoComplete="nickname"
              autoFocus
            />
          </Field>

          <Field label="Email">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </Field>

          <Field label="Password">
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={MIN_PASSWORD_LENGTH}
              autoComplete="new-password"
            />
          </Field>
          <p className={`text-xs ${tooShort ? 'text-negative' : 'text-muted'}`}>
            At least {MIN_PASSWORD_LENGTH} characters. Length beats punctuation.
          </p>

          <ErrorText error={register.error} />

          <Button type="submit" className="w-full" disabled={register.isPending}>
            {register.isPending ? 'Creating…' : 'Create account'}
          </Button>
        </form>
      </Card>

      <p className="mt-4 text-center text-sm text-muted">
        Already have an account?{' '}
        <Link to="/login" className="font-medium text-brand hover:underline">
          Sign in
        </Link>
      </p>
    </div>
  )
}
